import React, { useState, useCallback, useEffect } from 'react'
import ReactResponsiveModal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createFormOfEducation, updateFormOfEducation } from '../../actions/directory'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.scss'

const validationSchema = Yup.object({
  name: Yup.string().required('Заполните название').max(50, 'Должно быть не более 50 символов'),
})

export default function FormsOfEducationModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !data?.f_studyform

  const getInitialValues = (data) => addMode ? { name: '' } : { name: data.name }

  const handleCreate = (values) => {
    dispatch(createFormOfEducation({ name: values.name }, closeModal))
  }

  const handleUpdate = (values) => {
    dispatch(updateFormOfEducation({ id: data.f_studyform, name: values.name }, closeModal))
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    resetForm
  } = useFormik({
    initialValues: getInitialValues(data),
    validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (data) resetForm({ values: getInitialValues(data) })
  }, [data])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <ReactResponsiveModal
      open={!!data}
      onClose={handleClose}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      center
      classNames={{
        modal: styles.modal,
        modalContainer: styles.modalContainer
      }}
    >
      <>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление формы обучения' : 'Редактирование формы обучения'}</h2>

          <div className={styles.inputsColumn}>
            <Input
              label='Название'
              placeholder='до 50 символов'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              maxLength='50'
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </>
    </ReactResponsiveModal>
  )
}
